"use client";

import { Dispatch, SetStateAction, useEffect, useState, useTransition } from "react";
import { generateArticleHeaderImageGoogleGenAI } from "./actions";
import { CheckCircle2, Loader2 } from "lucide-react";
import CartaTokens from '@/../public/images/tokens_sm.png';
import { GetTokenCost } from "@/lib/tokensHandlers";
import Image from "next/image";
import HttpStatus from "@/lib/HttpStatus";

export default function HeaderImageSelector({ topic, images, setImages }: 
    { topic: string, images: string | null, setImages: Dispatch<SetStateAction<string | null>> }) {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [isPending, startTransition] = useTransition();
  const [ imageTokensCost, setImageTokensCost ] = useState<number>(0);

  useEffect(() => {
    async function getImageTokensCost() {
      try {
        const costResp = await GetTokenCost('ARTIMG01');
  
        if(costResp.status != HttpStatus.OK) {
          throw new Error(costResp.error!);
        }
        
        setImageTokensCost(costResp.data);
      } catch(error) {
        setImageTokensCost(0);
      }
    }

    getImageTokensCost();
  })

  const handleGenerate = () => {
    startTransition(async () => {
      const result = await generateArticleHeaderImageGoogleGenAI(topic);
      if (result.success) {
        setImages(result.data?.imageUrl!);
        // setSelectedImage(null); // Reset selection on new generation
      }
    });
  };

  return (
    <div className="p-6 border rounded-xl bg-white shadow-sm space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Article Header Image Options</h3>
        <button
          onClick={handleGenerate}
          disabled={isPending}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg disabled:bg-blue-300 flex items-center gap-2"
        >
          <div className="flex flex-row justify-center items-center gap-2">
            <div className="text-lg">
              {isPending && <Loader2 className="animate-spin h-4 w-4" />}
              {images ? "Regenerate Options" : "Generate Images"}
            </div>
            <div className="flex flex-row justify-center items-center gap-1">
              <span>{"("}</span><Image src={CartaTokens} width={20} height={20} alt="Carta AI Tokens" />
              <span className="ml-1">{imageTokensCost} tokens</span><span>{")"}</span>
            </div>
          </div>
        </button>
      </div>

      {/* 2. THE IMAGE GRID */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {isPending && !images ? (
          // Skeleton loader while generating
          [1, 2, 3].map((i) => (
            <div key={i} className="aspect-video bg-gray-100 animate-pulse rounded-lg" />
          ))
        ) : images ? (
            
        //   images.map((url, idx) => (
            <div
            //   key={idx}
              onClick={() => setSelectedImage(images)}
              className={`relative cursor-pointer rounded-lg overflow-hidden border-4 transition-all 
                ${selectedImage === images ? "border-blue-500 ring-4 ring-blue-100" : "border-transparent hover:border-gray-200"}`}
            >
                {/* <Image src={images!} alt="Generated Image" width={512} className="w-full aspect-video object-cover border-2 border-red-600" priority /> */}
              <img src={images!} alt={`Option 1`} className="w-full aspect-video object-cover" />
              
              {selectedImage === images && (
                <div className="absolute top-2 right-2 text-blue-500 bg-white rounded-full">
                  <CheckCircle2 size={24} />
                </div>
              )}
            </div>
        //   ))
        ) : null}
      </div>

      {/* 3. FINAL ACTION */}
      {selectedImage && (
        <div className="pt-4 border-t flex justify-end">
          <button className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
            Confirm Header Image
          </button>
        </div>
      )}
    </div>
  );
}